import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Checkbox,
  Button,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';

import {
  SpButton,
  SpError,
} from 'components/DesignKit';


type Props = {
  internalAccount: Object,
  paymentType: Object,
  submit: Function,
  openModal: Function,
};

const PaymentType = (props: Props) => {
  const {
    internalAccount,
    paymentType,
    submit,
    openModal,
  } = props;

  const [paymentMethodData, setPaymentMethodData] = useState((internalAccount && internalAccount.supportedPaymentTypes));
  const acquirerId = (internalAccount && internalAccount.acquirer)
    ? (internalAccount.acquirer && internalAccount.acquirer.id)
    : '';
  const [disabled, setDisabled] = useState(true);
  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator());

  const updatePaymentType = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }

    submit({
      acquirerId,
      paymentMethodData,
    });
  };

  const onCheckChange = (checkedValues) => {
    setPaymentMethodData(checkedValues);
    setDisabled(false);
    openModal(true);
  };

  function renderPaymentRows(data) {
    const content = [];
    data && data.forEach((result, i) => {
      if ((i + 1) % 2 === 0) {
        content.push(
          <Row className="mb-2">
            <Col span={12}>
              <Checkbox value={result.name}>
                {result.name.includes('NET_BANKING') ? (result.name).replace('NET_BANKING_', '') : result.name}
              </Checkbox>
            </Col>
          </Row>,
        );
      } else {
        content.push(
          <Col span={12}>
            <Checkbox value={result.name}>
              {result.name.includes('NET_BANKING') ? (result.name).replace('NET_BANKING_', '') : result.name}
            </Checkbox>
          </Col>,
        );
      }
    });
    return content;
  }

  useEffect(() => {
    setPaymentMethodData(internalAccount && internalAccount.supportedPaymentTypes);
    setDisabled(true);
  }, [openModal]);

  const reset = () => {
    setPaymentMethodData(internalAccount && internalAccount.supportedPaymentTypes);
    setDisabled(true);
    openModal(false);
  };

  return (
    <>
      <div>
        <Row className="mb-2">
          <Checkbox.Group style={{ width: '100%' }} value={paymentMethodData} onChange={onCheckChange}>
            <Row>
              {renderPaymentRows(paymentType)}
            </Row>
          </Checkbox.Group>
          <SpError>
            {simpleValidator.current.message('payment type', paymentMethodData, 'required')}
          </SpError>
        </Row>
        <Row className="mt-4" style={{ marginLeft: '-15px' }}>
          <Col span={2}>
            <Button
              type="link"
              onClick={reset}
              disabled={disabled}
            >
              Reset
            </Button>
          </Col>
          <Col span={2}>
            <SpButton
              type="primary"
              shape="round"
              disabled={disabled}
              onClick={updatePaymentType}
            >
              Update
            </SpButton>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default React.memo(PaymentType);
